import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DeregistrationPack} from '../../../shared/interface/deregistration-pack';
import {DeregistrationPackService} from '../../../shared/services/deregistration-pack.service';
import {ContractAddDialogComponent} from '../../contracts/contract-add-dialog/contract-add-dialog.component';
import {AddRegistrationComponent} from '../add-registration/add-registration.component';
import {
  DEREGISTRATION_PACK_STATUS_SENT,
  REGISTRATION_STATUS_TO_DEREGISTER
} from '../../../shared/services/dict.service';

@Component({
  selector: 'app-deregistration-pack-details',
  templateUrl: './deregistration-pack-details.component.html',
  styleUrls: ['./deregistration-pack-details.component.scss']
})
export class DeregistrationPackDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  readonly DEREGISTRATION_PACK_STATUS_SENT = DEREGISTRATION_PACK_STATUS_SENT;
  readonly REGISTRATION_STATUS_TO_DEREGISTER = REGISTRATION_STATUS_TO_DEREGISTER;

  deregistrationPackId: string;
  deregistrationPackObject?: DeregistrationPack;
  deregistrationPack: ReplaySubject<DeregistrationPack> = new ReplaySubject<DeregistrationPack>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  reloadRegistrations: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    private route: ActivatedRoute,
    private deregistrationPackService: DeregistrationPackService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.deregistrationPackId = params.id;
        this.loadDeregistrationPack();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadDeregistrationPack(): void {
    this.deregistrationPackService.get(this.deregistrationPackId).subscribe((deregistrationPack: DeregistrationPack) => {
      this.deregistrationPack.next(deregistrationPack);
      this.deregistrationPackObject = deregistrationPack;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych paczki', error.status.toString(), {
        duration: 2000
      });
    });
  }

  addRegistration(): void {
    const dialogRef = this.dialog.open(AddRegistrationComponent, {
      width: '50%',
      data: {deregistrationPackObject: this.deregistrationPackObject},
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.reloadRegistrations.next();
    });
  }
}
